<template>
  <div class="pages">
    <navTop :acIndex="3"></navTop>
    <div class="box">
      <!-- 内容 -->
      <div class="box-main">
        <div
            class="box-main-li"
            v-for="(item, index) in questionList"
            :key="index"
        >
          <div class="box-main-li-top">{{ item.title }}</div>
          <div class="box-main-li-title" v-html="item.detail"></div>
        </div>
      </div>
    </div>
    <navFooter></navFooter>
  </div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import navFooter from '../../components/navFooter.vue';

export default {
  name: 'problem',
  components: {
    navTop,
    navFooter
  },
  data() {
    return {
      questionList: []
    };
  },
  created() {
    if (!sessionStorage.getItem('uid')) {
      this.$router.push({path: '/'});
    } else {
      this.getQuestion();
    }
  },
  methods: {
    getQuestion() {
      this.$api.question({}).then(res => {
        console.log(res);
        if (res.result == 0) {
          this.questionList = res.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// 科技蓝色风格变量 - 使用 #1ba8e8 作为主色调
$blue-primary: #1ba8e8;
$blue-primary-rgba: rgba(27, 168, 232, 0.9);
$blue-secondary: #4ab9f0;
$blue-glow: rgba(27, 168, 232, 0.4);
$blue-light: rgba(27, 168, 232, 0.2);
$blue-dark: #0f2b3f;
$text-glow: 0 0 8px rgba(27, 168, 232, 0.5);

.pages {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  position: relative;
  min-height: 10vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(27, 168, 232, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .box {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 2;

    // 内容
    .box-main {
      margin-top: 30px;
      padding-bottom: 80px;
      box-sizing: border-box;

      .box-main-li {
        width: 100%;
        margin-bottom: 30px;
        border: 1px solid $blue-primary-rgba;
        border-radius: 35px;
        padding: 30px 0 50px 0;
        box-sizing: border-box;
        background: rgba(15, 43, 63, 0.6);
        backdrop-filter: blur(10px);
        box-shadow: 0 0 30px $blue-glow;
        transition: all 0.3s ease;

        &:hover {
          box-shadow: 0 5px 35px $blue-primary;
          border-color: $blue-primary;
        }

        .box-main-li-top {
          width: 277px;
          height: 49px;
          background: linear-gradient(90deg, $blue-primary 0%, $blue-secondary 100%);
          border-radius: 0 25px 25px 0;
          padding-left: 34px;
          box-sizing: border-box;
          font-size: 24px;
          font-weight: bold;
          color: #ffffff;
          line-height: 49px;
          text-align: left;
          text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
          box-shadow: 0 0 20px $blue-glow;
        }

        .box-main-li-title {
          padding: 30px 50px 0;
          box-sizing: border-box;

          ::v-deep img {
            width: 100%;
            height: 100%;
            display: block;
            border-radius: 8px;
            box-shadow: 0 0 20px $blue-glow;
          }

          ::v-deep p {
            font-size: 18px;
            color: #c0e4ff;
            line-height: 1.8;
            margin-bottom: 15px;
            text-shadow: 0 0 5px $blue-glow;

            &:last-child {
              margin-bottom: 0;
            }
          }

          ::v-deep h1, ::v-deep h2, ::v-deep h3, ::v-deep h4 {
            color: $blue-primary;
            text-shadow: $text-glow;
            margin-bottom: 15px;
          }

          ::v-deep a {
            color: $blue-primary;
            text-decoration: none;
            border-bottom: 1px solid $blue-primary;
            transition: all 0.3s ease;

            &:hover {
              color: lighten($blue-primary, 15%);
              border-bottom-color: lighten($blue-primary, 15%);
            }
          }

          ::v-deep ul, ::v-deep ol {
            padding-left: 20px;
            margin-bottom: 15px;

            li {
              color: #c0e4ff;
              font-size: 16px;
              line-height: 1.6;
              margin-bottom: 5px;
            }
          }

          ::v-deep strong, ::v-deep b {
            color: $blue-primary;
          }
        }
      }

      .box-main-li:last-child {
        margin: 0;
      }
    }
  }
}

// 底部样式
::v-deep .footer {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-top: 2px solid $blue-primary !important;
  box-shadow: 0 -5px 25px $blue-glow !important;
  position: relative;
  z-index: 2;

  .footer-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }

    .text {
      color: #c0e4ff !important;

      span {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .footer-right {
    .service {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .list {
        .li {
          color: #c0e4ff !important;

          &:hover {
            color: $blue-primary !important;
            text-shadow: $text-glow;
          }
        }
      }
    }

    .contact {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .item {
        color: #c0e4ff !important;

        img {
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    .qrcode {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 20px $blue-glow;
    }
  }

  // 其他网站区域
  .other-site {
    border-top: 1px solid rgba(27, 168, 232, 0.3) !important;
    margin-top: 30px !important;
    padding-top: 30px !important;

    .other-site-title {
      color: $blue-primary !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin-bottom: 15px !important;
      text-shadow: $text-glow;
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
      }
    }

    .other-site-links {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 15px !important;
      margin-bottom: 20px !important;

      .other-site-link-item {
        color: #c0e4ff !important;
        font-size: 14px !important;
        padding: 5px 15px !important;
        border: 1px solid rgba(27, 168, 232, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        cursor: pointer !important;

        &:hover {
          border-color: $blue-primary !important;
          box-shadow: 0 0 15px $blue-glow !important;
          color: $blue-primary !important;
          transform: translateY(-2px);
        }
      }
    }

    .other-site-copyright {
      color: #c0e4ff !important;
      font-size: 13px !important;
      line-height: 1.8 !important;
      text-align: center !important;

      a {
        color: $blue-primary !important;
        text-decoration: none !important;
        transition: all 0.3s ease !important;

        &:hover {
          color: lighten($blue-primary, 20%) !important;
          text-shadow: $text-glow;
        }
      }

      .icp {
        color: #c0e4ff !important;
        margin: 0 5px;

        span {
          color: $blue-primary !important;
        }
      }

      .beian {
        color: #c0e4ff !important;
        margin: 0 5px;

        a {
          color: $blue-primary !important;
        }
      }

      .company {
        color: $blue-primary !important;
        font-weight: bold;
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 1200px) {
  .pages {
    .box {
      padding-left: 15px;
      padding-right: 15px;

      .box-main {
        .box-main-li {
          padding: 25px 0 40px 0;

          .box-main-li-top {
            width: 240px;
            height: 45px;
            font-size: 22px;
            line-height: 45px;
            padding-left: 30px;
          }

          .box-main-li-title {
            padding: 25px 40px 0;

            ::v-deep p {
              font-size: 16px;
              line-height: 1.6;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .pages {
    .box {
      .box-main {
        .box-main-li {
          .box-main-li-top {
            width: 200px;
            height: 40px;
            font-size: 18px;
            line-height: 40px;
            padding-left: 25px;
          }

          .box-main-li-title {
            padding: 20px 25px 0;

            ::v-deep p {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>